import { Pipe, PipeTransform } from '@angular/core';
import { PlanType, PlanTypeTranslations } from 'src/app/core/interfaces/planType.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
  name: 'planType',
  pure: false
})
export class PlanTypePipe implements PipeTransform {

  constructor(private localizationService: LocalizationService) { }

  transform(value: PlanType | string): string {
    if (!value) {
      return '';
    }

    const currentLang = this.localizationService.getCachedLanguage();
    if (currentLang === 'ar') {
      return PlanTypeTranslations[value as PlanType] || value;
    } else {
      return value;
    }
  }
}
